module.exports = __webpack_public_path__ + "files/dd7a26f16823499d191fb20131d16405.png";